/** Pre-flight checks shown before opening registrations (warnings only, never blockers) */

import type { Event } from '@/types/event.types';

export interface ReadinessCheck {
  id: string;
  label: string;
  ok: boolean;
  /** What it means when the check is not ok */
  hint?: string;
}

export function getReadinessChecks(
  event: Pick<
    Event,
    'base_price' | 'registration_deadline' | 'payment_instructions' | 'payment_qr_filename' | 'flyer_filename'
  >,
  activeRuleCount: number,
  sessionCount: number,
  now: Date = new Date(),
): ReadinessCheck[] {
  const deadline = event.registration_deadline ? new Date(event.registration_deadline) : null;
  const deadlineIsFuture = !!deadline && deadline.getTime() > now.getTime();

  return [
    {
      id: 'price',
      label: 'Precio base definido',
      ok: Number(event.base_price ?? 0) > 0,
      hint: 'Sin precio base: la inscripción será gratuita.',
    },
    {
      id: 'rules',
      label: 'Reglas de precio activas',
      ok: activeRuleCount > 0,
      hint: 'Sin reglas activas: todos pagarán el precio base.',
    },
    {
      id: 'deadline',
      label: 'Plazo de inscripción vigente',
      ok: deadlineIsFuture,
      hint: deadline
        ? 'El plazo ya venció: el formulario público no aceptará inscripciones aunque abra el evento.'
        : 'Sin plazo de inscripción: estará abierto hasta que lo cierre manualmente.',
    },
    {
      id: 'payment',
      label: 'Instrucciones o QR de pago',
      ok: !!event.payment_instructions?.trim() || !!event.payment_qr_filename,
      hint: 'Los inscritos no verán cómo pagar.',
    },
    {
      id: 'sessions',
      label: 'Programa cargado',
      ok: sessionCount > 0,
      hint: 'El evento no tiene sesiones: no se podrá registrar asistencia por sesión.',
    },
    {
      id: 'flyer',
      label: 'Afiche del evento',
      ok: !!event.flyer_filename,
      hint: 'Sin afiche en el formulario público.',
    },
  ];
}
